import type { AppLinkQuery, AppLinkQueryScalar } from "./buildAppLink";

export function appLinkQueryEntries(
  query: AppLinkQuery | URLSearchParams | undefined,
): [string, AppLinkQueryScalar | readonly AppLinkQueryScalar[]][] {
  if (query instanceof URLSearchParams) {
    return [...query.entries()].map(([name, value]) => [name, [value]]);
  }
  return Object.entries(query ?? {});
}
